import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { queryListStyles } from '../../Styles/queryStyles';
import { inject, observer } from 'mobx-react';
import FeedbackDetails from './FeedbackDetails';
import { withRouter } from 'react-router-dom';
import Rating from '@material-ui/lab/Rating';
import { feedbackStyles } from '../../Styles/feedbackStyles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import FeedbackDialog from './FeedbackDialog';
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
const rating_labels = ["Terrible", "Bad", "Disappointing", "It’s Ok", "Great"];

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
@inject('feedbackStore', 'queryStore', 'commonStore')
@observer
class Feedback extends Component {

    state = {
        rating: 0,
        ratingText: '',
        errorMessage: '',
        feedbackText: '',
        email: ''
    }

    componentDidMount() {
        this.props.commonStore.setGoBackTo('pendingQueries')
        if (!this.props.queryStore.showFeedback)
            this.props.history.push({
                pathname: '/home',
            })
    }

    setRating = (event, value) => {
        this.setState({
            rating: value,
            ratingText: rating_labels[value - 1]
        })
    }

    sendFeedback = (tempId, type) => {
        const { rating, feedbackText, email } = this.state;

        if (rating == 0) {
            this.setState({
                errorMessage: 'Please provide a suitable rating before you submit.'
            })
            return;
        }
        else if (!feedbackText.trim().length && this.props.location.appState ) {
            this.setState({
                errorMessage: 'Please provide a suitable feedback before you submit.'
            })
            return;
        }
        /* else if (!email.trim().length
             && this.props.location.appState && this.props.location.appState.type === 'dissatisfied'
             && !emailRegex.test(email)
         ) {
             this.setState({
                 errorMessage: 'Please enter a valid Email ID before you submit.'
             })
             return;
         }*/
        this.setState({
            errorMessage: ''
        })

        this.props.feedbackStore.sendFeedback(type, tempId, feedbackText, rating)
            .then(() => {
                this.props.queryStore.setShowFeedback(false);
            })
    }

    render() {
        const { classes } = this.props;
        const { inProgress } = this.props.feedbackStore
        const { rating, ratingText, errorMessage, feedbackText, email } = this.state
        return (
            <div className={classes.feedbackContainer}>
                <div>
                    <p className={classes.feedbackInfo}>Your ticket has been closed and necessary changes have been updated.</p>
                    {this.props.location.appState ? <FeedbackDetails item={this.props.location.appState.item} ></FeedbackDetails> : null}
                    <div>
                        <p className={classes.feedbackText}>{ratingText}</p>
                        <div className={classes.feedbackInfo}>
                            <Rating
                                name="customized-empty"
                                size="large"
                                precision={1}
                                classes={{
                                    root: classes.star,
                                    iconHover: classes.starFocus,
                                    iconFilled: classes.starFocus,
                                    iconFocus: classes.starFocus,
                                    iconEmpty: classes.starEmpty
                                }}
                                value={rating}
                                onChange={(event, value) => this.setRating(event, value)}
                                emptyIcon={<StarBorderRoundedIcon fontSize="inherit" />}
                                icon={<StarRoundedIcon fontSize="inherit" />}
                            />
                            <div style={{ padding: '2vw', paddingTop: '4vh' }}>
                                <TextField
                                    value={feedbackText}
                                    required={this.props.location.appState && this.props.location.appState.type === 'dissatisfied' ? true : false}
                                    onChange={(e) => this.setState({ feedbackText: e.target.value })} className={classes.feedbackText} id="standard-basic" label="Write a note" fullWidth />
                                {/*this.props.location.appState && this.props.location.appState.type === 'dissatisfied' ?
                                    <TextField style={{ marginTop: '1vh' }} value={email} onChange={(e) => this.setState({ email: e.target.value })} className={classes.feedbackText} id="standard-basic" required={true} label="Email ID" fullWidth />
                                    : null
                               */ }
                                {errorMessage && errorMessage.length ?
                                    <div className={classes.error}>
                                        <ReactSVG src={Images.error} />
                                        <div className={classes.errorStyle}>{errorMessage}</div>
                                    </div> : null
                                }

                            </div>
                        </div>
                    </div>


                </div>
                <div>
                    {
                        inProgress ?
                            <Button variant="contained" className={classes.button} fullWidth style={{ width: '100%' }}>
                                <CircularProgress size={30} thickness={5} className={classes.loading} />
                            </Button> :
                            <Button variant="contained" style={{ width: '100px' }} className={classes.button} type="submit" onClick={(event) => this.sendFeedback(this.props.location.appState && this.props.location.appState.item.tempId, this.props.location.appState && this.props.location.appState.type)} fullWidth style={{ width: '100%' }} >
                                Submit Response
                                    </Button>
                    }

                </div>
                {this.props.feedbackStore.openFeedbackDialog ? <FeedbackDialog /> : null}
            </div>
        )
    }
}



Feedback.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(withStyles(feedbackStyles)(Feedback));
